module.exports = __webpack_public_path__ + "img/98e98b1.png";